export const PAYMENT_DETAILS_KEYS = ["Inn", "AccountNumber", "IdDeal"];

// Столбец «ИНН / УНП» раньше показывал реквизит из карточки компании Б24
// (ключ CompanyInn). Теперь значение идёт из 1С (ключ Inn), а старый ключ
// в сохранённых видах переносим на новый, иначе у всех, кто настраивал
// столбцы, колонка уехала бы в конец списка и потеряла видимость.
const RENAMED_KEYS = { CompanyInn: "Inn" };

const DEFAULT_COLUMNS = [
  { key: "DateDoc", title: "Дата документа", active: true },
  { key: "Org", title: "Организация", active: true },
  { key: "Partner", title: "Контрагент", active: true },
  { key: "Inn", title: "ИНН / УНП", active: true, exportAsText: true },
  { key: "AccountNumber", title: "Номер счёта", active: true, exportAsText: true },
  { key: "IdDeal", title: "ID сделки", active: true, exportAsText: true },
  { key: "Deal", title: "Сделка", active: true },
  { key: "ClientOrder", title: "Заказ", active: true },
  { key: "PostDS", title: "Поступление", active: true },
  { key: "Manager", title: "Менеджер", active: true },
  { key: "Sum", title: "Сумма", isNumeric: true, active: true },
  { key: "LeftTotal", title: "Итого слева", active: true },
  { key: "LeftAvgTotal", title: "Итого ср. слева", active: true },
  { key: "RightTotal", title: "Итого справа", active: true },
  { key: "RightAvgTotal", title: "Итого ср. справа", active: true },
];

// Old saved views must not remove the newly introduced columns from the menu.
export function mergePaymentColumns(saved = []) {
  const defaults = new Map(DEFAULT_COLUMNS.map(column => [column.key, column]));
  const result = [];
  (Array.isArray(saved) ? saved : []).forEach(column => {
    const key = RENAMED_KEYS[column.key] || column.key;
    const base = defaults.get(key);
    if (!base) return;
    // Название берём из кода, а не из сохранённой настройки: иначе
    // переименование столбца не дошло бы до тех, у кого сохранён вид.
    result.push({ ...base, ...column, key, title: base.title, exportAsText: base.exportAsText });
    defaults.delete(key);
  });
  defaults.forEach(column => result.push({ ...column }));
  return result;
}

// Правило текстовых ячеек общее для всех отчётов — см. textCellAttributes.
export { textCellAttributes as paymentTextAttributes } from "../../utils/table_export";
